import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
    fetchCurrentUserMostReleventSegment,
    getCurrentUserRelevantSegmentSuggestedBoardTitles,
} from '../../../user/account/onboarding/segmentPicker/currentUserSegmentUtil';
import { getOnboardingBoardTitle } from '../../boardTemplatePickerPopup/boardTemplatePickerSelectors';

const formatSuggestedBoardTitles = (titles: string[] | undefined): string | undefined => {
    if (!titles || titles.length === 0) return;

    // If there are multiple titles, join them with ' or '
    return titles
        .map((title) => `"${title}"`)
        .slice(0, 2)
        .join(' or ');
};

const OnboardingTooltipContentSuggestBoardNames = () => {
    const templateBoardTitle = useSelector(getOnboardingBoardTitle);
    const relevantSegmentSuggestedBoardTitles = useSelector(getCurrentUserRelevantSegmentSuggestedBoardTitles);

    const dispatch = useDispatch();

    useEffect(() => {
        if (templateBoardTitle) return;

        dispatch(fetchCurrentUserMostReleventSegment());
    }, []);

    const titlesList = templateBoardTitle ? [templateBoardTitle] : relevantSegmentSuggestedBoardTitles;
    const title = formatSuggestedBoardTitles(titlesList);

    if (!title) return <div className="secondary-text">&nbsp;</div>;

    return <div className="secondary-text">E.g. {title}</div>;
};

export default OnboardingTooltipContentSuggestBoardNames;
